import { FlowStateController } from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import { gsap } from "gsap";

import { AbstractView } from "../../../abstracts/modules/AbstractView";
import { displayConfig } from "../../config/DDDConfig";
import { DDDTotalWinScreen } from "./Screens/DDDTotalWinScreen";
import { DDDWaysWinScreen } from "./Screens/DDDWaysWinScreen";
import { DDDFreespinIntroScreen } from "./Screens/freespin/DDDFreespinIntroScreen";
import { DDDFreespinOutroScreen } from "./Screens/freespin/DDDFreespinOutroScreen";
import { DDDFreespinRestoreScreen } from "./Screens/freespin/DDDFreespinRestoreScreen";
import { DDDSuperFreespinIntroScreen } from "./Screens/superFreespin/DDDSuperFreespinIntroScreen";
import { DDDSuperFreespinOutroScreen } from "./Screens/superFreespin/DDDSuperFreespinOutroScreen";
import { DDDSuperFreespinRestoreScreen } from "./Screens/superFreespin/DDDSuperFreespinRestoreScreen";

export class DDDWinView extends AbstractView {
    public totalWinScreen: DDDTotalWinScreen;
    public waysWinScreen: DDDWaysWinScreen;

    private freespinIntroScreen: DDDFreespinIntroScreen;
    private freespinRestoreScreen: DDDFreespinRestoreScreen;
    private freespinOutroScreen: DDDFreespinOutroScreen;
    private superFreespinIntroScreen: DDDSuperFreespinIntroScreen;
    private superFreespinRestoreScreen: DDDSuperFreespinRestoreScreen;
    private superFreespinOutroScreen: DDDSuperFreespinOutroScreen;

    constructor() {
        super(`UCWinningsView`);
    }

    protected initGraphics() {
        super.initGraphics();

        this.totalWinScreen = new DDDTotalWinScreen(this);
        this.totalWinScreen.x = displayConfig.reelsViewWidth / 2;
        this.totalWinScreen.y = 360;

        this.waysWinScreen = new DDDWaysWinScreen(this);
        this.waysWinScreen.x = displayConfig.reelsViewWidth / 2;
        this.waysWinScreen.y = 360;

        this.freespinIntroScreen = new DDDFreespinIntroScreen(this);
        this.freespinIntroScreen.x = 360;
        this.freespinIntroScreen.y = 360;
        displayConfig.reelsViewHeight / 2 - this.freespinIntroScreen.height / 2;

        this.freespinRestoreScreen = new DDDFreespinRestoreScreen(this);
        this.freespinRestoreScreen.x = this.freespinIntroScreen.x;
        this.freespinRestoreScreen.y = this.freespinIntroScreen.y;

        this.freespinOutroScreen = new DDDFreespinOutroScreen(this);
        this.freespinOutroScreen.x = this.freespinIntroScreen.x;
        this.freespinOutroScreen.y = this.freespinIntroScreen.y;

        this.superFreespinIntroScreen = new DDDSuperFreespinIntroScreen(this);
        this.superFreespinIntroScreen.x = this.freespinIntroScreen.x;
        this.superFreespinIntroScreen.y = this.freespinIntroScreen.y;

        this.superFreespinRestoreScreen = new DDDSuperFreespinRestoreScreen(this);
        this.superFreespinRestoreScreen.x = this.freespinRestoreScreen.x;
        this.superFreespinRestoreScreen.y = this.freespinRestoreScreen.y;

        this.superFreespinOutroScreen = new DDDSuperFreespinOutroScreen(this);
        this.superFreespinOutroScreen.x = this.freespinOutroScreen.x;
        this.superFreespinOutroScreen.y = this.freespinOutroScreen.y;
    }

    public showFreespinIntroScreen(
        onClick: Function,
        fsLeft: number,
        isSuperFs: boolean = false
    ): void {
        const introScreen = isSuperFs ? this.superFreespinIntroScreen : this.freespinIntroScreen;
        const timeline = gsap.timeline({
            onStart: () => {
                this.addChild(introScreen);
            },
        });

        introScreen.onContinueBtnClick = onClick;

        if (introScreen === this.superFreespinIntroScreen) {
            timeline.add((introScreen as DDDSuperFreespinIntroScreen).getGsapAnimation(fsLeft));
        } else {
            timeline.add((introScreen as DDDFreespinIntroScreen).getGsapAnimation(fsLeft));
        }
    }

    public showFreespinRestoreScreen(
        fsLeft: number,
        onClick: Function,
        isSuperFs: boolean = false
    ): gsap.core.Timeline {
        const restoreScreen = isSuperFs
            ? this.superFreespinRestoreScreen
            : this.freespinRestoreScreen;
        const timeline = gsap.timeline({
            onStart: () => {
                this.addChild(restoreScreen);
            },
        });

        restoreScreen.onContinueBtnClick = onClick;

        timeline.add(restoreScreen.getGsapAnimation(fsLeft));

        return timeline;
    }

    public showFreespinOutroScreen(
        totalWin: number,
        onClick: Function,
        isSuperFs: boolean = false,
        itShouldPlaySound: boolean = true,
        controller: FlowStateController
    ): gsap.core.Timeline {
        const outroScreen = isSuperFs ? this.superFreespinOutroScreen : this.freespinOutroScreen;
        const timeline = gsap.timeline({
            onStart: () => {
                this.addChild(outroScreen);
            },
            onComplete: () => {
                controller?.setSkipCallback(undefined);
            },
        });

        outroScreen.onContinueBtnClick = onClick;

        timeline.addLabel(`outroScreenStart`, 0);
        timeline.add(outroScreen.getGsapAnimation(totalWin, itShouldPlaySound), `outroScreenStart`);
        timeline.addLabel(`outroScreenComplete`, `>-=0.2`);

        return timeline;
    }
}
